// Wrapper presse-papier cross-platform.
// - Web + WebView Capacitor : navigator.clipboard.writeText (contexte sécurisé https)
// - Fallback : textarea + execCommand('copy')
// NOTE : @capacitor/clipboard n'est pas installé dans NoiRock. La Clipboard API web
// fonctionne dans la WebView Capacitor ; ajouter le plugin natif seulement si un
// device pose problème (puis brancher la branche `isCapacitor()` ici).

export async function copy(text) {
  const value = String(text ?? '');
  if (!value) return { ok: false };

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return { ok: true, via: 'navigator' };
    } catch {
      // fallthrough to legacy
    }
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    ta.setAttribute('readonly', '');
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return { ok: true, via: 'execCommand' };
  } catch {
    return { ok: false };
  }
}

export async function readText() {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.readText) {
    try {
      return await navigator.clipboard.readText();
    } catch {
      /* fallthrough */
    }
  }
  return '';
}
